module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-11-2968fc8f759a8adae78b105784fe242a.jpg";